import { createColumnHelper } from '@tanstack/react-table'

export const columnHelper = createColumnHelper<APIPaymentInvoice>()

export const getCost = (invoice: APIPaymentInvoice) => {
  const { total, currency } = invoice

  const locale = 'en-CA' //navigator.languages[0] ?? 'en-US'
  const cost = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency.toLocaleUpperCase()
  }).format(total / 100.0)

  return cost
}
